import React from 'react';
import { DollarSign, Loader2 } from 'lucide-react';

const PricingControls = ({ 
  onShowGunPriceModal, 
  onShowPhotoPriceModal, 
  priceLoading 
}) => {
  return (
    <div className="dropdown-container">
      <button className="dropdown-toggle">
        <DollarSign size={16} />
        Pricing
      </button>
      <div className="dropdown-menu">
        <button
          className="dropdown-item"
          onClick={onShowGunPriceModal}
        >
          <DollarSign size={16} />
          Update Gun Prices
        </button>
        <button
          className="dropdown-item"
          onClick={onShowPhotoPriceModal}
          disabled={priceLoading}
        >
          {priceLoading ? (
            <Loader2 className="spin" size={16} />
          ) : (
            <DollarSign size={16} />
          )}
          Update Photo Price
        </button>
      </div>
    </div>
  );
};

export default PricingControls;